
<!--口令-->
<template>
  <div>
    <el-dialog
      title=""
      append-to-body="true"
      :visible.sync="showDlog"
      width="20%"
      center>
      <el-form ref="registerRef" @submit.native.prevent   :model="param" :rules="rules" label-width="120px" style="width: 700px" size="small">
        <el-form-item  label="输入口令"  prop="word">
          <el-input style="width: 200px" v-model="param.word" show-password placeholder=""></el-input>
        </el-form-item>
        <el-form-item  >
          <el-button  @click="onBtnSure('registerRef')" type="primary"    >确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
<style>

</style>
<script>

  export default {
    name: 'WorkerWord',

    props: {
      title:String,
      show: Boolean,
      wordType:Number,
      tData:Object,
    },
    data() {
      return {
        rules:{
          word:[{required:true,message:"口令不能为空",trigger:"blur"}]
        },
        param:{
          word:""
        },
        showDlog:false,
      }
    },
    created(){
      this.showDlog = this.show;
    },

    methods:{
      onBtnSure(registerRef){
        this.$refs[registerRef].validate((valid) => {
          console.log("onBtnSure onWorkerWord",this.tData)
          if (valid) {
            this.showDlog = false;
            this.show = false;
            this.tData.adminWord = this.param.word;

            this.$emit('onWorkerWord',this.wordType,this.tData);
          } else {
            return false
          }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/WorkerWord/WorkerWord.vue